var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('span',{staticClass:"c-meeting-slot-label"},[_vm._v(" "+_vm._s(`${_setup.getFormattedDate(_vm.start)}, `)),_c('span',{staticClass:"c-meeting-slot-label__time"},[_vm._v(_vm._s(_setup.getFormattedTimeRange(_vm.start, _vm.end)))])])
}
var staticRenderFns = []

export { render, staticRenderFns }